<ng-container *transloco="let t">
    <div
        class="loading-spinner flex flex-col items-center justify-center gap-4 text-center w-full py-12 sm:py-16 md:py-20 min-h-[50vh] sm:min-h-[60vh]"
        [ngClass]="containerClass"
        role="status"
        aria-live="polite"
        [attr.aria-label]="showLoadingText ? (loadingText || t('Loading...')) : t('Loading')"
    >
        <mat-progress-spinner [diameter]="diameter" [mode]="mode"></mat-progress-spinner>
        <span
            *ngIf="showLoadingText"
            class="w-full text-center flex justify-center mt-6 text-gradient text-lg sm:text-xl md:text-2xl"
            [ngClass]="textClass"
        >
            {{ loadingText || t('Loading...') }}
        </span>
    </div>
</ng-container>
